import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { ConfirmPhone as ConfirmPhoneForm } from "ui/auth/ConfirmPhone"

export const ConfirmPhone = () => (
  <AuthenticationLayout type="signup">
    <ConfirmPhoneForm />
  </AuthenticationLayout>
)
